<!-- <p>remove-user-dialog works!</p> -->
<h1 mat-dialog-title>Remove User</h1>
<mat-dialog-content class="mat-typography">
  <div class="remove-user-dialog-status">
    <strong>Do you really want to remove the user!</strong>
  </div>

  <mat-divider></mat-divider> </mat-dialog-content
><mat-dialog-actions align="end">
  <button mat-raised-button [mat-dialog-close]="false">Cancel</button>
  <button mat-raised-button [mat-dialog-close]="true">Remove</button>
</mat-dialog-actions>
